export const configCiPermission = {
    configCiTestTasksView: "config-ci-test-tasks.view",
    configCiTestCaseTasksView: "config-ci-test-case-tasks.view",
    configCiTestTaskProgressesView: "config-ci-test-task-progresses.view",
    configCiTestCaseTaskStatusesView: "config-ci-test-case-task-statuses.view",
    configCiTestCasesView: "config-ci-test-cases.view",
    configCiTestTaskCancel: "config-ci-test-task.cancel",
    configCiTestTaskRestart: "config-ci-test-task.restart",
    configCiTestCaseTaskCancel: "config-ci-test-case-task.cancel",
    configCiTestTaskSchedule: "config-ci-test-task.schedule"
};
